export enum NotificationSettingsFormField {
  Enabled = 'Enabled',
  Source = 'Source',
  Target = 'Target',
  Radius = 'Radius',
  Name = 'Name'
}
